import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { HelpWidget, HelpProvider } from "@/components/HelpWidget";
import ConnectSidePopup from "@/components/ConnectSidePopup";

export default function PublicLayout({ children }) {
  return (
    <HelpProvider>
      <div className="flex min-h-screen flex-col">
        <Header />
        <main className="flex-1">{children}</main>
        <Footer />
        <HelpWidget />
        {/* Compact connect popup — only renders on lawyer / legal-help routes */}
        <ConnectSidePopup />
      </div>
    </HelpProvider>
  );
}
